module.exports = __webpack_public_path__ + "img/contact-img-m.959cba0c.png";